import type { MagneticWallType } from '../../editor/editorSlice';

export type DisplayId<Id extends string = string> = `${MagneticWallType}-${Id}`;

function toDisplayId<Id extends string>(item: {
  id: Id;
  type: MagneticWallType;
}): DisplayId<Id> {
  return `${item.type}-${item.id}`;
}

export default toDisplayId;
